import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

@Component({
  selector: 'bmcore-edit-profile-page',
  templateUrl: './bmcore-edit-profile-page.component.html',
  styleUrls: ['./bmcore-edit-profile-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreEditProfilePageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
